<div class="is-relative">
    <form [formGroup]="form" class="content-type-form" isavFieldIndex>
        <isav-field-index></isav-field-index>

        <isav-text-input
            label="1. Title"
            formControlName="title"
            [mandatory]="true"
            tooltipKey="EducationAndTraining:title"
        ></isav-text-input>

        <isav-radio-input
            label="2. Course type"
            formControlName="education"
            trueLabel="Education"
            falseLabel="Training"
            [mandatory]="true"
            tooltipKey="EducationAndTraining:education"
        ></isav-radio-input>

        <isav-date-input
            label="3. Course start date"
            formControlName="startDate"
            [mandatory]="true"
            tooltipKey="EducationAndTraining:startDate"
        ></isav-date-input>

        <isav-date-input
            label="4. Course end date"
            formControlName="endDate"
            [mandatory]="true"
            tooltipKey="EducationAndTraining:endDate"
        ></isav-date-input>

        <isav-date-input
            label="5. Registration deadline"
            formControlName="registrationDeadline"
            [mandatory]="true"
            tooltipKey="EducationAndTraining:registrationDeadline"
        ></isav-date-input>

        <isav-taxonomy-select-input
            label="6. Organisation"
            formControlName="organisation"
            taxonomy="Organisation"
            [mandatory]="true"
            tooltipKey="EducationAndTraining:organisation"
        ></isav-taxonomy-select-input>

        <isav-department-input
            label="7. Departments"
            placeholder="Select department"
            [multiple]="true"
            formControlName="departments"
            [organisationIri]="this.form.value.organisation"
            tooltipKey="EducationAndTraining:departments"
        ></isav-department-input>

        <isav-link-input
            label="8. Link to course description"
            formControlName="linkToCourseRegistration"
            [mandatory]="true"
            tooltipKey="EducationAndTraining:linkToCourseRegistration"
        ></isav-link-input>

        <isav-taxonomy-checkbox-list-input
            label="9. Course topics"
            taxonomy="Topic"
            formControlName="topics"
            tooltipKey="EducationAndTraining:topics"
        ></isav-taxonomy-checkbox-list-input>

        <isav-taxonomy-select-input
            label="10. Teaching languages"
            formControlName="languages"
            taxonomy="Language"
            multiple
            tooltipKey="EducationAndTraining:languages"
        ></isav-taxonomy-select-input>

        <isav-taxonomy-select-input
            label="11. Teaching country"
            formControlName="teachingCountry"
            taxonomy="Country"
            [mandatory]="true"
            tooltipKey="EducationAndTraining:teachingCountry"
        ></isav-taxonomy-select-input>

        <isav-coordinates-input
            label="12. Teaching location"
            formControlName="teachingLocation"
            [mandatory]="true"
            tooltipKey="EducationAndTraining:teachingLocation"
        ></isav-coordinates-input>

        <isav-text-input
            label="13. Contact name"
            formControlName="contactName"
            [mandatory]="true"
            tooltipKey="EducationAndTraining:contactName"
        ></isav-text-input>

        <isav-text-input
            label="14. Contact email"
            formControlName="contactEmail"
            [mandatory]="true"
            tooltipKey="EducationAndTraining:contactEmail"
        ></isav-text-input>

        <isav-text-input
            label="15. Contact phone"
            formControlName="contactPhone"
            [mandatory]="true"
            tooltipKey="EducationAndTraining:contactPhone"
        ></isav-text-input>

        <isav-image-form
            label="16. Image"
            formControlName="image"
            tooltipKey="EducationAndTraining:image"
            property="image"
            [contentIri]="value['@id']"
        ></isav-image-form>

        <isav-document-input
            label="17. Attachments"
            formControlName="attachments"
            tooltipKey="EducationAndTraining:attachments"
            [multiple]="true"
        ></isav-document-input>

        <isav-content-editor
            label="18. Description"
            [mandatory]="true"
            formControlName="shortDescription"
            tooltipKey="EducationAndTraining:shortDescription"
            property="shortDescription"
            [iri]="value['@id']"
        ></isav-content-editor>

        <isav-taxonomy-select-input
            *ngIf="form.value.education"
            label="19. Course level"
            formControlName="courseLevel"
            taxonomy="CourseLevel"
            [mandatory]="true"
            tooltipKey="EducationAndTraining:courseLevel"
        ></isav-taxonomy-select-input>

        <isav-taxonomy-select-input
            *ngIf="form.value.education"
            label="20. Field of study"
            formControlName="studyField"
            taxonomy="CourseFieldOfStudy"
            [mandatory]="true"
            tooltipKey="EducationAndTraining:studyField"
        ></isav-taxonomy-select-input>

        <isav-text-input
            *ngIf="form.value.education"
            label="21. ECTS"
            formControlName="ects"
            tooltipKey="EducationAndTraining:ects"
        ></isav-text-input>

        <div class="is-flex is-space-between">
            <isav-go-to-view>Back to view</isav-go-to-view>
            <div class="buttons is-right">
                <ng-content></ng-content>
                <button type="button" isavBtn color="danger" class="ml-2" (click)="onDelete()">
                    Delete
                </button>
                <button
                    *ngIf="value.draft"
                    isavBtn
                    color="primary"
                    type="button"
                    [disabled]="isDisabled()"
                    (click)="onPublish()"
                >
                    Publish
                </button>
                <button
                    *ngIf="!value.draft"
                    isavBtn
                    color="danger"
                    type="button"
                    (click)="onUnpublish()"
                >
                    Unpublish
                </button>
                <button
                    type="button"
                    isavBtn
                    color="success"
                    [disabled]="!value.draft && isDisabled()"
                    (click)="onSave()"
                >
                    Save
                </button>
            </div>
        </div>
    </form>
</div>
